import { Grid, Skeleton, Card } from "@mui/material";
import { SkeletonForm } from "./skeletonForm";

export const SkeletonFirmaElectronica = () => {
  const items = [1, 2, 3, 4];
  return (
    <Card
      className="w-[92%] mx-auto px-9"
      sx={{
        borderRadius: "10px",
        paddingY: "24px",
        boxShadow: "0px 10px 20px rgba(0, 0, 0, 0.2)",
      }}
    >
      <Grid container spacing={4}>
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <SkeletonForm totalInputs={[1, 2, 3, 4]} />
          <div className="w-full flex justify-end my-4">
            <Skeleton variant="rounded" width="40%" />
          </div>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          {items.map((i) => (
            <div className="flex items-center my-2" key={i}>
              <Skeleton
                variant="circular"
                animation="wave"
                width={60}
                height={60}
                className="mr-3"
              />
              <Skeleton variant="rounded" width="100%" />
            </div>
          ))}
        </Grid>
      </Grid>
    </Card>
  );
};
